import { useState } from 'react';
import { useAuth, USUARIOS } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);

    setTimeout(() => {
      const found = USUARIOS.find(
        u => u.usuario === usuario.toLowerCase().trim() && u.pin === pin.trim()
      );

      if (!found) {
        setError('Usuario o contraseña incorrectos');
        setCargando(false);
        return;
      }

      login(found);
      navigate('/dashboard');
    }, 400);
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        {/* Avatar */}
        <div style={s.avatarWrap}>
          <div style={s.avatar}>
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="8" r="4" fill="rgba(255,255,255,0.7)" />
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="rgba(255,255,255,0.7)" strokeWidth="2" strokeLinecap="round" fill="none" />
            </svg>
          </div>
        </div>

        <h1 style={s.titulo}>Zoler Admin</h1>
        <p style={s.subtitulo}>Panel de administración</p>

        <form onSubmit={handleLogin} style={s.form}>
          <div style={s.fieldWrap}>
            <svg style={s.fieldIcon} width="16" height="16" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M3 9l9 6 9-6" stroke="currentColor" strokeWidth="1.5"/>
            </svg>
            <input
              style={s.input}
              type="text"
              placeholder="Usuario"
              value={usuario}
              onChange={e => setUsuario(e.target.value)}
              autoFocus
              autoComplete="off"
            />
          </div>

          <div style={s.fieldWrap}>
            <svg style={s.fieldIcon} width="16" height="16" viewBox="0 0 24 24" fill="none">
              <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M8 11V7a4 4 0 018 0v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <input
              style={s.input}
              type="password"
              placeholder="Contraseña"
              value={pin}
              onChange={e => setPin(e.target.value)}
            />
          </div>

          {error && <p style={s.error}>{error}</p>}

          <button style={{...s.boton, ...(cargando ? s.botonCargando : {})}} type="submit" disabled={cargando}>
            {cargando ? 'Verificando...' : 'LOGIN'}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a1040 0%, #2d1b6e 40%, #1a2a6e 100%)',
  },
  card: {
    background: 'rgba(255,255,255,0.08)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 24,
    padding: '40px 36px',
    width: 320,
    textAlign: 'center',
  },
  avatarWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 20,
  },
  avatar: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.1)',
    border: '2px solid rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titulo: {
    color: 'rgba(255,255,255,0.95)',
    fontSize: 22,
    fontWeight: '600',
    margin: '0 0 6px',
    letterSpacing: '-0.5px',
  },
  subtitulo: {
    color: 'rgba(255,255,255,0.45)',
    fontSize: 13,
    margin: '0 0 28px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
  },
  fieldWrap: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  fieldIcon: {
    position: 'absolute',
    left: 14,
    color: 'rgba(255,255,255,0.4)',
    pointerEvents: 'none',
    zIndex: 1,
  },
  input: {
    width: '100%',
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 10,
    padding: '13px 14px 13px 42px',
    color: 'rgba(255,255,255,0.9)',
    fontSize: 14,
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border 0.2s',
  },
  error: {
    color: '#f87171',
    fontSize: 13,
    margin: '0',
    textAlign: 'left',
    paddingLeft: 4,
  },
  boton: {
    background: 'linear-gradient(135deg, #5b4fcf, #3b5bdb)',
    border: 'none',
    borderRadius: 10,
    padding: '14px',
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
    letterSpacing: '1.5px',
    cursor: 'pointer',
    marginTop: 6,
    transition: 'opacity 0.2s, transform 0.1s',
  },
  botonCargando: {
    opacity: 0.7,
    cursor: 'default',
  },
};